import { getProxiedServiceUrl } from 'wmic-portals-url-js';
import { WMICJsonRPCService } from 'wmic-portals-transport-js';

export default class EmailQuoteService {
    static emailQuote(quoteEmailDTO, additionalHeaders = {}) {
        return WMICJsonRPCService.send(
            getProxiedServiceUrl('quote'),
            'emailQuote',
            [quoteEmailDTO],
            additionalHeaders
        );
    }
}
